import React, { useState } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

/**
 * A titled list the client can fold away, so a long list of packages doesn't
 * push the vouchers below it out of reach.
 */
function CollapsibleSection({ title, count = null, defaultOpen = true, labelSx, children }) {
  const [open, setOpen] = useState(defaultOpen);
  const toggle = () => setOpen((prev) => !prev);

  return (
    <Box>
      <Box
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggle();
          }
        }}
        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, cursor: "pointer", userSelect: "none" }}
      >
        <Typography sx={{ ...labelSx, mb: 0 }}>
          {title}
          {count != null ? ` · ${count}` : ""}
        </Typography>
        <ExpandMoreIcon
          fontSize="small"
          sx={{ color: "text.secondary", flexShrink: 0, transition: "transform 150ms", transform: open ? "rotate(180deg)" : "none" }}
        />
      </Box>
      <Collapse in={open}>
        <Box sx={{ mt: 1 }}>{children}</Box>
      </Collapse>
    </Box>
  );
}

export default CollapsibleSection;
